var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableHeaderIconActions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "19px",
    viewBox: "0 0 21 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-action") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Manage-Credit-Cards",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "00:-Table-of-Contents",
    transform: "translate(-724.000000, -474.000000)",
    fill: "#A1A5B3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(698.000000, 336.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-action",
    transform: "translate(26.000000, 138.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.262,11.22 L5.896,16.5 C5.544,17.05 5.698,17.798 6.27,18.15 C6.468,18.282 6.688,18.348 6.908,18.348 C7.304,18.348 7.7,18.15 7.92,17.798 L11.22,12.628 L10.318,12.21 C9.878,11.99 9.504,11.638 9.262,11.22 Z",
    id: "Path-Copy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.856,8.052 C20.702,7.524 20.152,7.216 19.624,7.348 L18.15,7.766 L17.424,6.138 C17.204,5.654 16.852,5.236 16.412,4.95 L14.696,3.828 C14.19,3.498 13.574,3.344 12.98,3.388 L10.45,3.586 C10.186,3.608 9.944,3.74 9.768,3.938 L8.052,5.962 C7.7,6.38 7.744,7.018 8.162,7.37 C8.58,7.722 9.218,7.678 9.57,7.26 L11.022,5.544 L12.54,5.434 L10.362,9.35 C10.208,9.636 10.164,9.988 10.274,10.296 C10.384,10.604 10.604,10.868 10.912,11.022 L14.278,12.606 L12.408,15.158 C12.012,15.686 12.144,16.434 12.672,16.83 C12.892,16.984 13.134,17.072 13.376,17.072 C13.75,17.072 14.102,16.896 14.344,16.588 L17.072,12.848 C17.292,12.562 17.358,12.188 17.27,11.836 C17.182,11.484 16.94,11.198 16.61,11.044 L14.256,9.922 L15.884,7.524 L16.698,9.35 C16.852,9.724 17.226,9.944 17.622,9.944 C17.71,9.944 17.798,9.922 17.886,9.9 L20.196,9.262 C20.702,9.13 21.01,8.58 20.856,8.052 Z",
    id: "Path-Copy-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.584,9.086 L5.654,9.086 C6.138,9.086 6.534,8.69 6.534,8.206 C6.534,7.722 6.138,7.326 5.654,7.326 L1.584,7.326 C1.1,7.326 0.704,7.722 0.704,8.206 C0.726,8.69 1.1,9.086 1.584,9.086 Z",
    id: "Path-Copy-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.928,11.264 L0.88,11.264 C0.396,11.264 8.73079387e-13,11.66 8.73079387e-13,12.144 C8.73079387e-13,12.628 0.396,13.024 0.88,13.024 L4.95,13.024 C5.434,13.024 5.83,12.628 5.83,12.144 C5.83,11.66 5.412,11.264 4.928,11.264 Z",
    id: "Path-Copy-5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    cx: 17.336,
    cy: 2.112,
    r: 2.112
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.31,5.148 L6.38,5.148 C6.864,5.148 7.26,4.752 7.26,4.268 C7.26,3.784 6.864,3.388 6.38,3.388 L2.31,3.388 C1.826,3.388 1.43,3.784 1.43,4.268 C1.43,4.752 1.826,5.148 2.31,5.148 Z",
    id: "Path-Copy-3"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableHeaderIconActions);
export default __webpack_public_path__ + "static/media/table-header-icon-actions.820c73f3683968f46248efc5594af468.svg";
export { ForwardRef as ReactComponent };